import { Address, IAddress } from '../../../models/address.model';
import { Transport } from '../../../models/transport.model';
import { IContact } from '../../../models/contact.model';
import { Civility } from '../../../models/enums/civility.enum';

export class TransportMapper {
  static getPickupAddress(transport: Transport): IAddress {//TODO: A mettre dans abstractTransport
    return new Address({
      fullname: transport.pickupAddressFullname,
      streetNumber: transport.pickupAddressStreetNumber,
      street: transport.pickupAddressStreet,
      zipCode: transport.pickupAddressZipCode,
      city: transport.pickupAddressCity,
      cityCode: transport.pickupAddressInseeCode,
      country: transport.pickupAddressCountry,
      additionals: transport.pickupAddressAdditionals,
      gps_coords: transport.pickupAddressGpsCoords
    });
  }

  static getDeliveryAddress(transport: Transport): IAddress {//TODO: A mettre dans abstractTransport
    return new Address({
      fullname: transport.deliveryAddressFullname,
      streetNumber: transport.deliveryAddressStreetNumber,
      street: transport.deliveryAddressStreet,
      zipCode: transport.deliveryAddressZipCode,
      city: transport.deliveryAddressCity,
      cityCode: transport.deliveryAddressInseeCode,
      country: transport.deliveryAddressCountry,
      additionals: transport.deliveryAddressAdditionals,
      gps_coords: transport.deliveryAddressGpsCoords
    });
  }

  static updatePickupAddress(transport: Transport, address: IAddress, contact?: IContact): void {
    transport.pickupAddressStreetNumber = address.streetNumber;
    transport.pickupAddressStreet = address.street ?? undefined;
    transport.pickupAddressCity = address.city ?? undefined;
    transport.pickupAddressZipCode = address.zipCode ?? undefined;
    transport.pickupAddressInseeCode = address.cityCode;
    transport.pickupAddressFullname = address.fullname ?? undefined;
    transport.pickupAddressAdditionals = address.additionals;
    transport.pickupAddressCountry = address.country ?? undefined;
    transport.pickupAddressGpsCoords = address.gps_coords;

    if (contact) {
      transport.pickupContactCivility = contact.civility ?? Civility.MALE;
      transport.pickupContactFirstName = contact.firstName;
      transport.pickupContactLastName = contact.lastName;
      transport.pickupContactMail = contact.mail;
      transport.pickupContactPhone = contact.phone;
    }
  }

  static updateDeliveryAddress(transport: Transport, address: IAddress, contact?: IContact): void {
    transport.deliveryAddressStreetNumber = address.streetNumber;
    transport.deliveryAddressStreet = address.street ?? undefined;
    transport.deliveryAddressCity = address.city ?? undefined;
    transport.deliveryAddressZipCode = address.zipCode ?? undefined;
    transport.deliveryAddressInseeCode = address.cityCode;
    transport.deliveryAddressFullname = address.fullname ?? undefined;
    transport.deliveryAddressAdditionals = address.additionals;
    transport.deliveryAddressCountry = address.country ?? undefined;
    transport.deliveryAddressGpsCoords = address.gps_coords;

    if (contact) {
      transport.deliveryContactCivility = contact.civility ?? Civility.MALE;
      transport.deliveryContactFirstName = contact.firstName;
      transport.deliveryContactLastName = contact.lastName;
      transport.deliveryContactMail = contact.mail;
      transport.deliveryContactPhone = contact.phone;
    }
  }
}
